import { sections } from "../../components/Global/Widgets/Map/MapComponents/UniversitySections/geoSections";
import { TCategories, TSection } from "./types";

/**
 * Given a selected section on the map, the function returns the
 * categories that should be displayed on Step 1 of the report form.
 *
 * @param section selected section on map ('A', 'B', etc)
 * @returns Array of categories
 */
export const mappedCategoriesBySection = (section: TSection) => {
  let categories = [] as TCategories;
  switch (section) {
    case "a_reitoria":
    case "A - Reitoria":
      categories = [
        {
          icon: "CampusWifi",
          name: "Wi-Fi",
          id: "1e57b03d977f55501782f87de053af4d",
        },
        {
          icon: "CampusEnergy",
          name: "Energia/Iluminação",
          id: "e2957c79977f55501782f87de053af85",
        },
        {
          icon: "CampusWaste",
          name: "Resíduos/Lixo",
          id: "96e5f0b9977f55501782f87de053afac",
        },
        {
          icon: "CampusWatersSewers",
          name: "Águas e Esgotos",
          id: "a60638b9977f55501782f87de053afa4",
        },
        /*
        {
          icon: "CampusBuildings",
          name: "Campus Edifícios",
          id: "6b77b43d977f55501782f87de053afc1",
        },
        */
        {
          icon: "CampusOthers",
          name: "Outro assunto",
          id: "6b77b43d977f55501782f87de053afbc",
        },
      ];
      break;
    case "b_polidesportivo":
    case "B - Polidesportivo":
      categories = [
        {
          icon: "CampusWifi",
          name: "Wi-Fi",
          id: "1a57b03d977f55501782f87de053af4c",
        },
        {
          icon: "CampusEnergy",
          name: "Energia/Iluminação",
          id: "e6957c79977f55501782f87de053af99",
        },
        {
          icon: "CampusWaste",
          name: "Resíduos/Lixo",
          id: "92e534b9977f55501782f87de053af94",
        },
        {
          icon: "CampusWatersSewers",
          name: "Águas e Esgotos",
          id: "2a0638b9977f55501782f87de053afad",
        },
        /*
        {
          icon: "CampusBuildings",
          name: "Campus Edifícios",
          id: "a377f43d977f55501782f87de053af2a",
        },
        */
        {
          icon: "CampusOthers",
          name: "Outro assunto",
          id: "a377f43d977f55501782f87de053af2a",
        },
      ];
      break;
    case "c_facDireito":
    case "C - Faculdade de Direito":
      categories = [
        {
          icon: "CampusWifi",
          name: "Wi-Fi",
          id: "1257b03d977f55501782f87de053af4a",
        },
        {
          icon: "CampusEnergy",
          name: "Energia/Iluminação",
          id: "66957c79977f55501782f87de053af95",
        },
        {
          icon: "CampusWaste",
          name: "Resíduos/Lixo",
          id: "d6e534b9977f55501782f87de053af8f",
        },
        {
          icon: "CampusWatersSewers",
          name: "Águas e Esgotos",
          id: "6e0638b9977f55501782f87de053afa8",
        },
        /*
        {
          icon: "CampusBuildings",
          name: "Campus Edifícios",
          id: "ab77f43d977f55501782f87de053af27",
        },
        */
        {
          icon: "CampusOthers",
          name: "Outro assunto",
          id: "ab77f43d977f55501782f87de053af27",
        },
      ];
      break;
    case "d_residencia":
    case "D - Residência Alfredo de Sousa":
      categories = [
        {
          icon: "CampusWifi",
          name: "Wi-Fi",
          id: "1257b03d977f55501782f87de053af4f",
        },
        {
          icon: "CampusEnergy",
          name: "Energia/Iluminação",
          id: "2e957c79977f55501782f87de053af87",
        },
        {
          icon: "CampusWaste",
          name: "Resíduos/Lixo",
          id: "5ae534b9977f55501782f87de053af92",
        },
        {
          icon: "CampusWatersSewers",
          name: "Águas e Esgotos",
          id: "a60638b9977f55501782f87de053afaa",
        },
        /*
        {
          icon: "CampusBuildings",
          name: "Campus Edifícios",
          id: "a777f43d977f55501782f87de053af2b",
        },
        */
        {
          icon: "CampusOthers",
          name: "Outro assunto",
          id: "a777f43d977f55501782f87de053af2b",
        },
      ];
      break;
    case "e_colegio":
    case "E - Colégio Almada Negreiro":
      categories = [
        {
          icon: "CampusWifi",
          name: "Wi-Fi",
          id: "da57b03d977f55501782f87de053af48",
        },
        {
          icon: "CampusEnergy",
          name: "Energia/Iluminação",
          id: "aa957c79977f55501782f87de053af7b",
        },
        {
          icon: "CampusWaste",
          name: "Resíduos/Lixo",
          id: "dee5f0b9977f55501782f87de053afad",
        },
        {
          icon: "CampusWatersSewers",
          name: "Águas e Esgotos",
          id: "e20638b9977f55501782f87de053afa7",
        },
        /*
        {
          icon: "CampusBuildings",
          name: "Campus Edifícios",
          id: "6777f43d977f55501782f87de053af26",
        },
        */
        {
          icon: "CampusOthers",
          name: "Outro assunto",
          id: "6777f43d977f55501782f87de053af26",
        },
      ];
      break;
    case "f_IMS":
    case "F - NOVA IMS":
    case "g_IMS_SU":
    case "G - Nova IMS/SU":
      categories = [
        {
          icon: "CampusWifi",
          name: "Wi-Fi",
          id: "1657b03d977f55501782f87de053af4b",
        },
        {
          icon: "CampusEnergy",
          name: "Energia/Iluminação",
          id: "aa957c79977f55501782f87de053af82",
        },
        {
          icon: "CampusWaste",
          name: "Resíduos/Lixo",
          id: "12e534b9977f55501782f87de053af91",
        },
        {
          icon: "CampusWatersSewers",
          name: "Águas e Esgotos",
          id: "ee0638b9977f55501782f87de053afab",
        },
        /*
        {
          icon: "CampusBuildings",
          name: "Campus Edifícios",
          id: "af77f43d977f55501782f87de053af28",
        },
        */
        {
          icon: "CampusOthers",
          name: "Outro assunto",
          id: "af77f43d977f55501782f87de053af28",
        },
      ];
      break;
    case "ext1_estacionamento_norte":
    case "1 - Estacionamento Norte":
    case "ext2_estacionamento_este":
    case "2 - Estacionamento Este":
    case "ext3_exterior_central":
    case "3 - Espaço Exterior Central":
    case "ext4_estacionamento_oeste":
    case "4 - Estacionamento Oeste (NOVA Law e RAS)":
    case "ext5_estacionamento_CAN":
    case "5 - Estacionamento Exclusivo CAN":
    case "ext6_estacionamento_sul":
    case "6 - Estacionamento Sul":
      categories = [
        {
          icon: "CampusWifi",
          name: "Wi-Fi",
          id: "4657b03d977f55501782f87de053af43",
        },
        {
          icon: "CampusGreenSpaces",
          name: "Espaços Verdes",
          id: "2777f43d977f55501782f87de053af4e",
        },
        {
          icon: "CampusEnergy",
          name: "Energia/Iluminação",
          id: "66957c79977f55501782f87de053af97",
        },
        {
          icon: "CampusParking",
          name: "Cancelas e Estacionamento",
          id: "9e28f47d977f55501782f87de053af20",
        },
        {
          icon: "CampusWaste",
          name: "Resíduos/Lixo",
          id: "4ae5f0b9977f55501782f87de053afa9",
        },
        {
          icon: "CampusWatersSewers",
          name: "Águas e Esgotos",
          id: "aa0638b9977f55501782f87de053afb1",
        },
        {
          icon: "CampusOthers",
          name: "Outro assunto",
          id: "2f77f43d977f55501782f87de053af4b",
        },
      ];
      break;
    default:
      categories = [];
      break;
  }
  return categories;
};

export const mappedSectionName = (section: TSection) =>
  sections.find((sect) => sect.name === section)?.keyName;

/*
  import { sections } from "../../components/Global/Widgets/Map/MapComponents/UniversitySections/geoSections";
  import { TCategories, TSection } from "./types";
  
  export const mappedCategoriesBySection = (section: TSection) => {
    let categories = [] as TCategories;
    switch (section) {
      case "a_reitoria":
      case "A - Reitoria":
        categories = [
          {
            icon: "CampusWifi",
            name: "Campus Wi-Fi",
            id: "1e57b03d977f55501782f87de053af4d",
          },
          {
            icon: "CampusEnergy",
            name: "Campus Energia",
            id: "e2957c79977f55501782f87de053af85",
          },
          {
            icon: "CampusWaste",
            name: "Campus Resíduos",
            id: "96e5f0b9977f55501782f87de053afac",
          },
          {
            icon: "CampusWatersSewers",
            name: "Campus Águas e Esgotos",
            id: "a60638b9977f55501782f87de053afa4",
          },
          {
            icon: "CampusBuildings",
            name: "Campus Edifícios",
            id: "6b77b43d977f55501782f87de053afc1",
          },
          {
            icon: "CampusOthers",
            name: "Outro assunto",
            id: "6b77b43d977f55501782f87de053afbc",
          },
        ];
        break;
      case "b_polidesportivo":
      case "B - Polidesportivo":
        categories = [
          {
            icon: "CampusWifi",
            name: "Campus Wi-Fi",
            id: "1a57b03d977f55501782f87de053af4c",
          },
          {
            icon: "CampusEnergy",
            name: "Campus Energia",
            id: "e6957c79977f55501782f87de053af99",
          },
          {
            icon: "CampusWaste",
            name: "Campus Resíduos",
            id: "92e534b9977f55501782f87de053af94",
          },
          {
            icon: "CampusWatersSewers",
            name: "Campus Águas e Esgotos",
            id: "2a0638b9977f55501782f87de053afad",
          },
          {
            icon: "CampusBuildings",
            name: "Campus Edifícios",
            id: "a377f43d977f55501782f87de053af2a",
          },
          {
            icon: "CampusOthers",
            name: "Outro assunto",
            id: "a377f43d977f55501782f87de053af2a",
          },
        ];
        break;
      case "c_facDireito":
      case "C - Faculdade de Direito":
        categories = [
          {
            icon: "CampusWifi",
            name: "Campus Wi-Fi",
            id: "1257b03d977f55501782f87de053af4a",
          },
          {
            icon: "CampusEnergy",
            name: "Campus Energia",
            id: "66957c79977f55501782f87de053af95",
          },
          {
            icon: "CampusWaste",
            name: "Campus Resíduos",
            id: "d6e534b9977f55501782f87de053af8f",
          },
          {
            icon: "CampusWatersSewers",
            name: "Campus Águas e Esgotos",
            id: "6e0638b9977f55501782f87de053afa8",
          },
          {
            icon: "CampusBuildings",
            name: "Campus Edifícios",
            id: "ab77f43d977f55501782f87de053af27",
          },
          {
            icon: "CampusOthers",
            name: "Outro assunto",
            id: "ab77f43d977f55501782f87de053af27",
          },
        ];
        break;
      case "d_residencia":
      case "D - Residência Alfredo de Sousa":
        categories = [
          {
            icon: "CampusWifi",
            name: "Campus Wi-Fi",
            id: "1257b03d977f55501782f87de053af4f",
          },
          {
            icon: "CampusEnergy",
            name: "Campus Energia",
            id: "2e957c79977f55501782f87de053af87",
          },
          {
            icon: "CampusWaste",
            name: "Campus Resíduos",
            id: "5ae534b9977f55501782f87de053af92",
          },
          {
            icon: "CampusWatersSewers",
            name: "Campus Águas e Esgotos",
            id: "a60638b9977f55501782f87de053afaa",
          },
          {
            icon: "CampusBuildings",
            name: "Campus Edifícios",
            id: "a777f43d977f55501782f87de053af2b",
          },
          {
            icon: "CampusOthers",
            name: "Outro assunto",
            id: "a777f43d977f55501782f87de053af2b",
          },
        ];
        break;
      case "e_colegio":
      case "E - Colégio Almada Negreiro":
        categories = [
          {
            icon: "CampusWifi",
            name: "Campus Wi-Fi",
            id: "da57b03d977f55501782f87de053af48",
          },
          {
            icon: "CampusEnergy",
            name: "Campus Energia",
            id: "aa957c79977f55501782f87de053af7b",
          },
          {
            icon: "CampusWaste",
            name: "Campus Resíduos",
            id: "dee5f0b9977f55501782f87de053afad",
          },
          {
            icon: "CampusWatersSewers",
            name: "Campus Águas e Esgotos",
            id: "e20638b9977f55501782f87de053afa7",
          },
          {
            icon: "CampusBuildings",
            name: "Campus Edifícios",
            id: "6777f43d977f55501782f87de053af26",
          },
          {
            icon: "CampusOthers",
            name: "Outro assunto",
            id: "6777f43d977f55501782f87de053af26",
          },
        ];
        break;
      case "f_IMS":
      case "F - NOVA IMS":
      case "g_IMS_SU":
      case "G - Nova IMS/SU":
        categories = [
          {
            icon: "CampusWifi",
            name: "Campus Wi-Fi",
            id: "1657b03d977f55501782f87de053af4b",
          },
          {
            icon: "CampusEnergy",
            name: "Campus Energia",
            id: "aa957c79977f55501782f87de053af82",
          },
          {
            icon: "CampusWaste",
            name: "Campus Resíduos",
            id: "12e534b9977f55501782f87de053af91",
          },
          {
            icon: "CampusWatersSewers",
            name: "Campus Águas e Esgotos",
            id: "ee0638b9977f55501782f87de053afab",
          },
          {
            icon: "CampusBuildings",
            name: "Campus Edifícios",
            id: "af77f43d977f55501782f87de053af28",
          },
          {
            icon: "CampusOthers",
            name: "Outro assunto",
            id: "af77f43d977f55501782f87de053af28",
          },
        ];
        break;
      case "ext1_estacionamento_norte":
      case "1 - Estacionamento Norte":
      case "ext2_estacionamento_este":
      case "2 - Estacionamento Este":
      case "ext3_exterior_central":
      case "3 - Espaço Exterior Central":
      case "ext4_estacionamento_oeste":
      case "4 - Estacionamento Oeste (NOVA Law e RAS)":
      case "ext5_estacionamento_CAN":
      case "5 - Estacionamento Exclusivo CAN":
      case "ext6_estacionamento_sul":
      case "6 - Estacionamento Sul":
        categories = [
          {
            icon: "CampusWifi",
            name: "Campus Wi-Fi",
            id: "4657b03d977f55501782f87de053af43",
          },
          {
            icon: "CampusGreenSpaces",
            name: "Campus Espaços Verdes",
            id: "2777f43d977f55501782f87de053af4e",
          },
          {
            icon: "CampusEnergy",
            name: "Campus Energia",
            id: "66957c79977f55501782f87de053af97",
          },
          {
            icon: "CampusParking",
            name: "Campus Cancelas e Estacionamento",
            id: "9e28f47d977f55501782f87de053af20",
          },
          {
            icon: "CampusWaste",
            name: "Campus Resíduos",
            id: "4ae5f0b9977f55501782f87de053afa9",
          },
          {
            icon: "CampusWatersSewers",
            name: "Campus Águas e Esgotos",
            id: "aa0638b9977f55501782f87de053afb1",
          },
          {
            icon: "CampusOthers",
            name: "Outro assunto",
            id: "2f77f43d977f55501782f87de053af4b",
          },
        ];
        break;
      default:
        categories = [];
        break;
    }
    return categories;
  };
  
  export const mappedSectionName = (section: TSection) =>
    sections.find((sect) => sect.name === section)?.keyName;
*/  